export default __webpack_public_path__ + "static/media/pixel-dl-instagram-post.504f562d.png";